var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamForwardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62946 6.85271C6.57053 6.91341 6.50659 6.96464 6.43932 7.00919L1.93935 11.6598C1.50035 12.1133 0.788122 12.1135 0.348912 11.6596C-0.0902973 11.2059 -0.0902973 10.47 0.348912 10.0158L4.22433 6.01049L0.328919 1.98427C-0.11029 1.53055 -0.11029 0.794871 0.328919 0.340505C0.548628 0.113215 0.836644 2.69164e-07 1.12404 2.56525e-07C1.41143 2.43886e-07 1.69965 0.113215 1.91915 0.340505L6.43932 5.01265C6.50659 5.05721 6.57094 5.10843 6.62946 5.16913C6.85396 5.40116 6.96225 5.70679 6.95684 6.01092C6.96225 6.31505 6.85396 6.62047 6.62946 6.85271Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamForwardIcon);
export default __webpack_public_path__ + "static/media/teamForwardIcon.55ef9f281ef33dbbdd3394551dc97ec6.svg";
export { ForwardRef as ReactComponent };